<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Terms of Use Agreement
      </p>
    </header>
    <div class="modal-card-body">
      <iframe v-bind:src="termsUrl" ref="termsFrame" />
    </div>
    <div class="modal-card-foot has-text-right is-justify-content-flex-end">
      <p v-if="!scrolledThrough">
        You must scroll to the bottom of the text above before you can agree. &nbsp;&nbsp;&nbsp;
      </p>
      <b-button
        class="is-primary"
        v-bind:disabled="!scrolledThrough"
        v-on:click="doAgree"
      >
        I Agree
      </b-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        scrolledThrough: false,
      }
    },
    components: {},
    props: {
      messages: Array,
    },
    methods: {
      doAgree: function() {
        fetch('/advisor-dashboard/terms-agreement/', {
          method: 'POST',
          headers: {
            'X-CSRFToken': this.$root.$data.csrfToken,
          },
        }).then((resp) => {
          return resp.json();
        }).then((data) => {
          this.$parent.close();
        });
      }
    },
    computed: {
      termsUrl: function() {
        return this.$root.advisor.hasFeature('FAFN Direct Indexing') ?
           '/terms-of-use-vadis/?is_iframe=1'
           : '/terms-of-use/?is_iframe=1';
      }
    },
    created: function() {
    },
    mounted: function() {
      var self = this;
      self.$refs.termsFrame.addEventListener('load', () => {
        const doc = self.$refs.termsFrame.contentDocument;
        const win = self.$refs.termsFrame.contentWindow;
        doc.addEventListener('scroll', (evt) => {
          if (win.scrollY >= doc.body.clientHeight - win.innerHeight - 350) { // 350px fudge factor in case of weird browser things
            self.scrolledThrough = true;
          }
        });
      })
    }
  }
</script>

<style lang="scss" scoped>
.modal-card-body {
  padding: 0;
}

iframe {
  width: 100%;
  height: 50vh;
}
</style>
